const componentStyles = (theme) => ({
  header: {
    position: "relative",
    background:
      "linear-gradient(87deg, #e9ecef 0, #e9eaef 100%) !important",
    paddingBottom: "7rem",
    paddingTop: "1rem",
    [theme.breakpoints.up("md")]: {
      paddingTop: "4rem",
    },
  },
  containerRoot: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "39px",
      paddingRight: "39px",
    },
  },
  title: {
    // color: theme.palette.white.main,
    fontSize: "1.25rem",
    fontWeight: 600,
    lineHeight: 1.5,
    paddingTop: "1.5rem",
    paddingBottom: "1.5rem",
  },
  cardRoot: {
    marginBottom: "1.5rem",
    height: "inherit",
    [theme.breakpoints.up("lg")]: {
      height: "100%",
    },
    [theme.breakpoints.up("xl")]: {
      marginBottom: 0,
    },
  },
  cardRootBgGradient: {
    background:
      "linear-gradient(87deg, #f5365c 0, #f56036 100%) !important",
  },
  cardContentRoot: {
    padding: "1rem 1.5rem !important",
  },

});

export default componentStyles;